module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/array/from.js
 ** module id = 470
 ** module chunks = 0
 **/